module.exports = __webpack_public_path__ + "static/media/18.d3bac894.jpg";